const Clock = () => (
  <svg
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="white"
    width="17px"
    height="17px"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <title>clock</title> <desc>Created with Sketch Beta.</desc> <defs> </defs>{" "}
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        {" "}
        <g
          id="Icon-Set"
          transform="translate(-412.000000, -359.000000)"
          fill="white"
        >
          {" "}
          <path
            d="M438,376 L440,376 L440,374 L438,374 L438,376 Z M428,389 C420.268,389 414,382.732 414,375 C414,367.269 420.268,361 428,361 C435.732,361 442,367.269 442,375 C442,382.732 435.732,389 428,389 L428,389 Z M428,359 C419.163,359 412,366.164 412,375 C412,383.837 419.163,391 428,391 C436.837,391 444,383.837 444,375 C444,366.164 436.837,359 428,359 L428,359 Z M434.076,367.273 L435.46,368.66 L436.844,367.273 L435.46,365.887 L434.076,367.273 L434.076,367.273 Z M433.783,381.778 L435.197,383.192 L436.611,381.778 L435.197,380.364 L433.783,381.778 L433.783,381.778 Z M428,363 C427.448,363 427,363.447 427,364 L427,374.023 L419,374.023 C418.447,374.023 418,374.472 418,375.024 C418,375.576 418.447,376.023 419,376.023 L428,376.023 C428.553,376.023 429,375.576 429,375.024 L429,364 C429,363.447 428.553,363 428,363 L428,363 Z M421.692,367.323 L420.278,365.909 L418.864,367.323 L420.278,368.737 L421.692,367.323 L421.692,367.323 Z M418.733,381.832 L420.117,383.219 L421.501,381.832 L420.117,380.445 L418.733,381.832 L418.733,381.832 Z M427,387 L429,387 L429,385 L427,385 L427,387 Z"
            id="clock"
          >
            {" "}
          </path>{" "}
        </g>{" "}
      </g>{" "}
    </g>
  </svg>
);

export default Clock;
